export { default as MetadataEditor } from './SourceEditor';
